import { Helmet } from 'react-helmet-async';

export function OrganizationSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "LocalCraft Israel",
    "alternateName": "LocalCraftIsrael",
    "url": "https://localcraftisrael.com",
    "logo": "https://localcraftisrael.com/pwa-512x512.png",
    "description": "Authentic handmade crafts from verified Israeli artisans. Discover unique gifts, jewelry, judaica, pottery, and textiles crafted by local artists across Israel.",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "IL",
      "addressLocality": "Israel"
    },
    "sameAs": [
      "https://facebook.com/localcraftisrael",
      "https://instagram.com/localcraftisrael"
    ],
    "founder": {
      "@type": "Organization",
      "name": "LocalCraft Israel"
    },
    "foundingDate": "2024",
    "slogan": "Authentic Israeli Handmade Crafts from Local Artisans",
    "keywords": "handmade Israel, Israeli artisan crafts, authentic crafts from Israel, local Israeli artists, gifts from Israel, made in Israel, Israeli jewelry, judaica, pottery",
    "areaServed": {
      "@type": "Country",
      "name": "Israel"
    },
    "makesOffer": {
      "@type": "Offer",
      "itemOffered": {
        "@type": "Product",
        "category": "Handmade Crafts"
      }
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
}
